import request from '@/utils/request.js';

// 客户跟进接口api
export function CreateCustomerFollowUp(data) {
    // 新增跟进信息
    return request({
        url: '/CustomerFollowUp/CreateCustomerFollowUp',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function GetCustomerFollowUpPageList(data) {
    // 跟进管理分页列表
    return request({
        url: '/CustomerFollowUp/GetCustomerFollowUpPageList',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function GetCustomerFollowUpList(data) {
    // 获取客户跟进信息
    return request({
        url: '/CustomerFollowUp/GetCustomerFollowUpList?' + `CustomerId=${data.Id}`,
        method: 'post',
        apiType: 'java'
    });
}

export function SipCreateCustomerFollowUpAndUpdateCustomerInfo(data) {
    // sip群呼跟进客户
    return request({
        url: '/CustomerFollowUp/SipCreateCustomerFollowUpAndUpdateCustomerInfo',
        method: 'post',
        data
    });
}
